<section>
    <xm-autocomplete id="international-search" ariaLabel="Search Countries" [items]="autocompleteOptions" [disabledItems]="disabledSuggestions" (onSelect)="suggestionSelected($event)" (clearInputEmit)="clearInputSearch($event)">
        <input [attr.aria-label]="textBoxPlaceHolder" 
       role="combobox" 
       aria-controls="international-search-results"
       aria-autocomplete="list"
       #searchBox 
       type="text" 
       [(ngModel)]="query" 
       placeholder="{{ textBoxPlaceHolder }}" 
       tabindex="0"/>
    </xm-autocomplete>
</section>
